<template>
  <div class="kt-portlet kt-portlet--mobile">
    <!--begin::Form-->
    <form class="kt-form" ref="form" @submit.prevent="formSubmit($event)">
      <div class="kt-portlet__head kt-portlet__head--lg">
        <div class="kt-portlet__head-label">
          <span class="kt-portlet__head-icon">
            <i class="kt-font-brand flaticon-home"></i>
          </span>
          <h3 class="kt-portlet__head-title">
            {{ this.$route.meta.breadcrumb }}
          </h3>
        </div>
      </div>
      <div class="kt-portlet__body">
        <div class="kt-section kt-section--first">
          <div class="row">
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
              <div class="form-group">
                <label class="label">รหัสคลังสินค้า:</label>
                <span class="form-control-plaintext">{{ StePlantId }}</span>
              </div>
            </div>
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
              <div class="form-group">
                <label class="label">ชื่อคลังสินค้า:</label>
                <span class="form-control-plaintext">{{ StePlantName }}</span>
              </div>
            </div>
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
              <div class="form-group">
                <label class="label">อีเมล:</label>
                <input
                  id="SteEmail"
                  name="SteEmail"
                  v-model="SteEmail"
                  type="text"
                  class="form-control"
                />
              </div>
            </div>
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
              <div class="form-group">
                <label>ประเภทคลังสินค้า:</label>
                <treeselect v-model="OwnerTypeCode" :options="OwnerTypeCodeOption"
                  :clear-on-select="true" placeholder="กรุณาเลือก"
                />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
              <div class="form-group">
                <label class="label">ที่อยู่:</label>
                <input
                  id="SteAddress"
                  name="SteAddress"
                  v-model="SteAddress"
                  type="text"
                  class="form-control"
                />
              </div>
            </div>
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
              <div class="form-group">
                <label class="label-required">จังหวัด:</label>
                <select2
                  :class="'form-control m-select2'"
                  :style="'width: 100%;'"
                  :id="'steProvinceId'"
                  :name="'steProvinceId'"
                  :select2-options="steProvinceIdOptions"
                  @selectChange="onProvinceChange"
                  v-model="steProvinceId"
                  ref="steProvinceIdSelect2"
                ></select2>
                <span class="form-text"></span>
              </div>
            </div>
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
              <div class="form-group">
                <label class="label-required">อำเภอ:</label>
                <select2
                  :class="'form-control m-select2'"
                  :style="'width: 100%;'"
                  :id="'steAmphurId'"
                  :name="'steAmphurId'"
                  :select2-options="steAmphurIdOptions"
                  @selectChange="onAmphurChange"
                  v-model="steAmphurId"
                  ref="steAmphurIdSelect2"
                ></select2>
                <span class="form-text"></span>
              </div>
            </div>
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
              <div class="form-group">
                <label class="label-required">ตำบล:</label>
                <select2
                  :class="'form-control m-select2'"
                  :style="'width: 100%;'"
                  :id="'steTumbolId'"
                  :name="'steTumbolId'"
                  :select2-options="steTumbolIdOptions"
                  v-model="steTumbolId"
                  ref="steTumbolIdSelect2"
                ></select2>
                <span class="form-text"></span>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
              <div class="form-group">
                <label class="label">ชื่อผู้ติดต่อ:</label>
                <input
                  id="SteContactName"
                  name="SteContactName"
                  v-model="SteContactName"
                  type="text"
                  class="form-control"
                />
              </div>
            </div>
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
              <div class="form-group">
                <label class="label">เบอร์โทร:</label>
                <input
                  id="SteTel"
                  name="SteTel"
                  v-model="SteTel"
                  type="text"
                  class="form-control"
                />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
              <div class="form-group">
                <label class="label">ผลิตสินค้า:</label>
                <div class="form-check">
                  <label class="form-check-label kt-checkbox">
                    <input
                      id="SteManufacture"
                      name="SteManufacture"
                      v-model="SteManufacture"
                      type="checkbox"
                      class="form-check-input"
                    />
                    เปิดใช้งาน
                    <span></span>
                  </label>
                </div>
              </div>
            </div>
            <!-- Begin:UseStockCoverDays element (CR-StockCoverDays F6) -->
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
              <div class="form-group">
                <label>ใช้งาน Stock Cover Days:</label>
                <div class="form-check">
                  <label class="form-check-label kt-checkbox">
                    <input
                      id="SteUseStockCoverDays"
                      name="SteUseStockCoverDays"
                      v-model="SteUseStockCoverDays"
                      type="checkbox"
                      class="form-check-input"
                    />
                    เปิดใช้งาน
                    <span></span>
                  </label>
                </div>
              </div>
            </div>
            <!-- End:UseStockCoverDays element -->
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
              <div class="form-group">
                <label class="label">ผลิตภัณฑ์:</label>
                <!-- <select2
                  :class="'form-control m-select2'"
                  :style="'width: 100%;'"
                  :id="'SteProduct'"
                  :name="'SteProduct'"
                  :multiple="true"
                  :select2-options="SteProductOptions"
                  v-model="SteProduct"
                  ref="SteProductSelect2"
                ></select2> -->
                <treeselect
                  v-model="SteProduct"
                  :multiple="true"
                  :options="SteProductOptions"
                  :clear-on-select="true"
                  placeholder="กรุณาเลือก"
                />
                <span class="form-text"></span>
              </div>
            </div>
          </div>
          <!-- Begin:Map element -->
          <div class="row">
            <div class="col-xl-12">
              <div class="form-group">
                <label class="label">ตำแหน่งที่ตั้ง:</label>
                <div v-if="SteLat === null">
                  <button
                    type="button"
                    class="btn m-btn--pill btn-info btn-block col-xl-2"
                    @click="getMap"
                  >
                    ระบุข้อมูลตำแหน่งที่ตั้ง
                  </button>
                </div>
                <div v-else>
                  <GmapMap
                    :center="{ lat: SteLat, lng: SteLng }"
                    :zoom="15"
                    :clickable="true"
                    @click="updateCoordinates"
                    style="width: 500px; height: 300px"
                  >
                    <gmap-marker
                      :key="index"
                      v-for="(m, index) in markers"
                      :position="m.position"
                      :draggable="true"
                      @drag="updateCoordinates"
                      :clickable="true"
                      @click="updateCoordinates"
                    ></gmap-marker>
                  </GmapMap>
                  <br />
                  <div>
                    <button
                      type="button"
                      class="btn btn-sm btn-secondary"
                      @click="openMap()"
                    >
                      <i class="far fa-map"></i> Open GoogleMaps
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- End:Map element -->
          <!-- Begin:Picture element -->
          <div class="row">
            <div class="col-xl-12">
              <div class="form-group">
                <label class="label">รูปภาพ:<span class="text-sm text-danger" style="font-size:small">
                    (เลือกได้เฉพาะสกุลไฟล์ JPG,JPEG,PNG ขนาดไม่เกิน 10Mb.)</span></label>
                <button
                  type="button"
                  class="btn m-btn--pill btn-info btn-block uploader-btn col-xl-2"
                  @click="uploadFile"
                >
                  <i class="flaticon-upload-1"></i>รูป
                </button>
                <div class="row" style="margin-top: 2%;" id="container-img">
                  <div v-for="image in FileUpload"
                       :key="image.pictureId"
                       v-if="image.isLoaded"
                       class="col-md-4 m--margin-top-20 loader loader-secondary bg-overlay img-wrap"
                       :id="image.pictureId">
                    <img :src="image.urlImg"
                         class="img-plant -avatar js-avatar-me img-thumbnail card-img-top"
                         @error="handleImageError(image)"
                         @load="handleImageLoad(image)" />
                    <a href="javascript:;"
                       style="position:absolute;top:10px;right:20px;"
                       class="btn m-btn--pill btn-danger m-btn btm-remove-img-plant close"
                       @click="removeImage(image.pictureId)">
                      <span class="m--font-inverse-danger la la-trash"></span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- End:Picture element -->

          <!-- Begin:InActiveStatus element -->
          <div class="row">
            <div class="col-xl-12">
              <div class="form-group">
                <label>สถานะ:</label>
                <div class="form-check">
                  <label class="form-check-label kt-checkbox">
                    <input
                      id="SteInActiveStatus"
                      name="SteInActiveStatus"
                      v-model="SteInActiveStatus"
                      type="checkbox"
                      class="form-check-input"
                    />
                    เปิดใช้งาน
                    <span></span>
                  </label>
                </div>
              </div>
            </div>
          </div>
          <!-- End:InActiveStatus element -->
        </div>
      </div>
      <div class="kt-portlet__foot">
        <button
          type="button"
          class="btn btn-secondary"
          data-dismiss="modal"
          @click="$router.go(-1)"
        >
          <i class="la la-close"></i> ย้อนกลับ
        </button>
        <button type="submit" class="btn btn-primary">
          <i class="la la-save"></i> บันทึกข้อมูล
        </button>
      </div>
    </form>
    <!--end::Form-->
  </div>
</template>

<script>
import axios from "axios";
import select2 from "../../../Shared/Select2";
import Vue from "vue";
import * as VueGoogleMaps from "vue2-google-maps";
import Treeselect from "@riophae/vue-treeselect";
// import the styles
import "@riophae/vue-treeselect/dist/vue-treeselect.css";

Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyCeGao-PkONmiyVksl46W_OUHt854bcrqE",
    libraries: "places",

    //// If you want to set the version, you can do so:
    // v: '3.26',
  },
});

export default {
  components: {
    select2,
    Treeselect,
  },
  name: "GoogleMap",
  data: function() {
    var self = this;
    return {
      StePlantId: null,
      StePlantName: null,
      SteAddress: null,
      SteContactName: null,
      SteProduct: [],
      SteTel: null,
      SteEmail: null,
      SteManufacture: false,
      SteUseStockCoverDays: false,
      SteInActiveStatus: null,
      steProvinceId: null,
      steAmphurId: null,
      steTumbolId: null,
      FileUpload: [],
      SteProductOptions: [],
      OwnerTypeCode: null,
      OwnerTypeCodeOption: [],
      // SteProductOptions: {
      //   multiple: true,
      //   placeholder: "กรุณาเลือก",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Product/Select2Product",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      steProvinceIdOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/MasterLocation/Select2SearchProvince",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
            };
            return JSON.stringify(query);
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
      steAmphurIdOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/MasterLocation/Select2SearchAmpher",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function(params) {
            var query = {
              provinceId: self.steProvinceId,
              search: params.term,
              page: params.page || 1,
            };
            return JSON.stringify(query);
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
      steTumbolIdOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/MasterLocation/Select2SearchTumbol",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function(params) {
            var query = {
              ampherId: self.steAmphurId,
              search: params.term,
              page: params.page || 1,
            };
            return JSON.stringify(query);
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
      SteLat: null,
      SteLng: null,
      markers: [],
    };
  },
  methods: {
    handleImageError(image) {
      image.isLoaded = false;
    },
    handleImageLoad(image) {
      image.isLoaded = true;
    },
    removeImage(pictureId) {
      Swal.fire({
        title: "ยืนยันคำสั่ง",
        text: "คุณต้องการลบรูปภาพนี้หรือไม่",
        confirmButtonText: "<span><i class='la la-check'></i><span>ฉันต้องการลบรูปภาพนี้</span></span>",
        confirmButtonClass: "btn btn-danger m-btn m-btn--pill m-btn--icon",
        showCancelButton: true,
        cancelButtonText: "<span><i class='la la-close'></i><span>ยกเลิก</span></span>",
        cancelButtonClass: "btn btn-secondary m-btn m-btn--pill m-btn--icon"
      }).then((result) => {
        if (result.value) {
          this.FileUpload = this.FileUpload.filter(
            (img) => img.pictureId !== pictureId
          );
          Swal.fire("ลบสำเร็จ!", "ลบรูปภาพเรียบร้อยแล้ว", "success");
        }
      });
    },
    uploadFile() {
      const input = document.createElement("input");
      input.type = "file";
      input.accept = "image/jpeg,image/png,image/jpg";
      input.click();

      input.addEventListener("change", (event) => {
        const files = event.target.files;
        Array.from(files).forEach((file) => {
          if (
            ["image/jpeg", "image/jpg", "image/png"].includes(file.type) &&
            file.size <= 10 * 1024 * 1024
          ) {
            const reader = new FileReader();
            reader.onload = (e) => {
              const newImage = {
                pictureId: Date.now().toString(),
                fileName: file.name,
                urlImg: e.target.result,
                fileDataContext: file,
                isNew: true,
                isLoaded: true,
              };
              this.FileUpload.push(newImage);
            };
            reader.readAsDataURL(file);
          } else {
            alert(
              "กรุณาเลือกไฟล์ภาพที่ถูกต้อง (JPG, JPEG, PNG ขนาดไม่เกิน 10MB)"
            );
          }
        });
      });
    },
    async formSubmit(e) {
      if (
        !$(this.$refs.form)
          .validate()
          .form()
      ) {
        return false;
      }

      let router = this.$router;
      let self = this;

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังบันทึกข้อมูล กรุณารอสักครู่...",
      });

      let uploadedFiles = [];

      // Upload new files to GCS
      for (let file of this.FileUpload) {
        if (file.isNew && file.fileDataContext) {
          try {
            const formData = new FormData();
            formData.append("File", file.fileDataContext);
            formData.append("IsMaster", true);
            formData.append("FolderName", "MasterPlant");

            const uploadResponse = await axios.post("/Api/File/FileUpload", formData, {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            });

            uploadedFiles.push({
              contentType: "-",
              downloadUrl: uploadResponse.data.fileUrl,
              fileInfoId: uploadResponse.data.fileInfoId,
              fileName: uploadResponse.data.fileInfoId,
              gridFsId: uploadResponse.data.gridFsId,
              sysName: "-",
            });
          } catch (error) {
            console.error("เกิดข้อผิดพลาดในการอัปโหลดไฟล์:", error);
          }
        } else if (!file.isNew) {
          // Keep existing files
          uploadedFiles.push(file);
        }
      }

      const picturesData = uploadedFiles.length > 0 ? uploadedFiles : [];

      axios
        .put("/Api/Plant", {
          PlantId: this.$route.params.Plantid,
          Email: this.SteEmail,
          Tel: this.SteTel,
          ContactName: this.SteContactName,
          Address: this.SteAddress,
          TumbolId: this.steTumbolId,
          AmphurId: this.steAmphurId,
          ProvinceId: this.steProvinceId,
          Latitude: this.SteLat,
          Longitude: this.SteLng,
          Manufacture: this.SteManufacture,
          UseStockCoverDays: this.SteUseStockCoverDays,
          InActiveStatus: !this.SteInActiveStatus,
          Products: this.SteProduct,
          PlantPictures: picturesData,
          OwnerTypeCode: this.OwnerTypeCode
        })
        .then(function(response) {
          if (response.data.status) {
            KTApp.unblockPage();
            Swal.fire("สำเร็จ", response.data.message, "success").then(
              function() {
                router.go(-1), self.$parent.reloadDataTable(false);
              }
            );
          } else {
            Swal.fire("เกิดข้อผิดพลาด", response.data.message, "error");
          }
        })
        .catch(function(error) {
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        })
        .then(function() {
          // always executed
          KTApp.unblockPage();
        });
    },
    getMap: function() {
      //get current lat,lon by IP
      navigator.geolocation.getCurrentPosition((position) => {
        this.SteLat = position.coords.latitude;
        this.SteLng = position.coords.longitude;
        this.markers = [
          {
            position: { lat: this.SteLat, lng: this.SteLng },
            animation: google.maps.Animation.DROP,
          },
        ];
      });
    },
    openMap() {
      var self = this;
      window.open(
        "https://www.google.com/maps/search/?api=1&query=" +
          self.SteLat +
          "," +
          self.SteLng,
        "_blank"
      );
    },

    //get current lat,lng (dragable)
    updateCoordinates(location) {
      this.SteLat = location.latLng.lat();
      this.SteLng = location.latLng.lng();
      map: this.map;
      this.markers = [{ position: { lat: this.SteLat, lng: this.SteLng } }];
    },
    onProvinceChange(id, value, data, ref) {
      $("#steAmphurId")
        .val("")
        .trigger("change");

      $("#steTumbolId")
        .val("")
        .trigger("change");
    },
    onAmphurChange(id, value, data, ref) {
      $("#steTumbolId")
        .val("")
        .trigger("change");
    },
    LoadSteProductOptions: function(e) {
      var self = this;
      axios
        .get("/Api/Product/Select2Product", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.SteProductOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    LoadOwnerTypeCodeOption: function(e) {
      var self = this;
      axios
        .get("/Api/Variables/Options?search=MASTER_OWNER_TYPE", {
          params: {
            page: 1,
            all: true,
            searchCode: "OWNER_PLANT"
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.OwnerTypeCodeOption.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
  },
  async mounted() {
    let self = this;
    let router = this.$router;
    let user = await this.$root.getUser();
    self.LoadSteProductOptions();
    self.LoadOwnerTypeCodeOption();

    KTApp.blockPage({
      opacity: 0.05,
      message: "กำลังดึงข้อมูล กรุณารอสักครู่...",
    });

    axios
      .get("/Api/Plant/" + this.$route.params.Plantid)
      .then(function(response) {
        if (response.status == 200) {
          self.StePlantId = response.data.plantId;
          self.StePlantName = response.data.plantDesc;
          self.SteAddress = response.data.address;
          self.SteContactName = response.data.contact;
          self.SteEmail = response.data.email;
          self.SteTel = response.data.tel;
          self.SteManufacture = response.data.manufacture;
          self.SteUseStockCoverDays = response.data.useStockCoverDays;
          self.OwnerTypeCode = response.data.ownerTypeCode;
          if (response.data.products) {
            response.data.products.forEach((x) => {
              self.SteProduct.push(x.materialCode);
            });

            // var productOptions = $.map(response.data.products, function(
            //   obj,
            //   idx
            // ) {
            //   return {
            //     id: obj.materialCode,
            //     text: obj.materialDesc_th,
            //   };
            // });
            //self.$refs.SteProductSelect2.setSelectedData(productOptions);
          }
          setTimeout(() => {
            if (response.data.ampherId) {
              self.$refs.steAmphurIdSelect2.setSelectedData({
                id: response.data.ampherId,
                text: response.data.ampherName,
              });
            }

            setTimeout(() => {
              if (response.data.tumbolId) {
                self.$refs.steTumbolIdSelect2.setSelectedData({
                  id: response.data.tumbolId,
                  text: response.data.tumbolName,
                });
              }
            }, 50);
          }, 100);

          if (response.data.provinceId) {
            self.$refs.steProvinceIdSelect2.setSelectedData({
              id: response.data.provinceId,
              text: response.data.provinceName,
            });
          }

          self.SteInActiveStatus = !response.data.inActiveStatus;
          //Set lat lng
          response.data.latitude === null
            ? (self.SteLat = null)
            : (self.SteLat = parseFloat(response.data.latitude));
          response.data.longitude === null
            ? (self.SteLng = null)
            : (self.SteLng = parseFloat(response.data.longitude));

          self.markers = [{ position: { lat: self.SteLat, lng: self.SteLng } }];

          // Load existing images to FileUpload array (GCS format)
          self.FileUpload = response.data.pictures.map((element) => ({
            pictureId: element.pictureId,
            fileName: element.fileName,
            fileInfoId: element.fileInfoId,
            downloadUrl: element.downloadUrl,
            urlImg: element.urlImg,
            gridFsId: element.gridFsId,
            sysName: element.sysName,
            isNew: false,
            isLoaded: true,
          }));
        } else {
          Swal.fire(
            "เกิดข้อผิดพลาด",
            "ไม่พบข้อมูลคลังสินค้าคุณเลือก",
            "warning"
          );
          router.go(-1);
        }
      })
      .catch(function(error) {
        Swal.fire(
          "เกิดข้อผิดพลาด",
          "ระบบเกิดข้อผิดพลาด ไม่สามารถดึงข้อมูลคลังสินค้าได้ในขณะนี้",
          "error"
        );
        router.go(-1);
      })
      .then(function() {
        // always executed
        KTApp.unblockPage();
      });

    //set validation rules
    $(this.$refs.form).validate({
      rules: {
        steProvinceId: "required",
        steAmphurId: "required",
        steTumbolId: "required",
      },
      messages: {
        steProvinceId: "กรุณาเลือกจังหวัด",
        steAmphurId: "กรุณาเลือกอำเภอ",
        steTumbolId: "กรุณาเลือกตำบล",
      },
    });
  },
};
</script>
<style lang="scss">
#myProgress {
  width: 100%;
  background-color: #ddd;
}

.myBar {
  width: 10%;
  height: 30px;
  background-color: #4caf50;
  text-align: center;
  line-height: 30px;
  color: white;
}

.btm-reload-img-plant {
  position: absolute;
  top: 5px;
  right: 20px;
}
.btm-delete-img-plant {
  position: absolute;
  top: 5px;
  right: 70px;
}
.btm-remove-img-plant {
  position: absolute;
  top: 5px;
  right: 20px;
}

.select2,
.select2-dropdown {
  font-size: 1.2rem;
}

@media (max-width: 425px) {
  .m-body .m-content {
    padding: 20px 5px;
  }
}

@media (max-width: 1200px) {
  .m-wizard.m-wizard--2 {
    margin-top: 8rem !important;
  }

  #activity_wizard .m-wizard__form .m-form .m-portlet__body {
    padding: 2.2rem 0 !important;
  }
}
</style>



// WEBPACK FOOTER //
// App/Components/Master/Plant/PlantUpdate.vue